<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="items">
        <template v-slot:item.active="{ item }">
          <v-checkbox
            :disabled="!props.allowedEdit"
            :data-cy="'module-' + item.id + '-active'"
            :true-value="1"
            :false-value="0"
            :model-value="slots[item.value]"
            hide-details>
          </v-checkbox>
          <span v-if="item.monthEnd">(Noch bis zum Ende des Monats)</span>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s
            data-cy="old-monthly-costs"
            v-if="oldMonthlyCost !== 0 && oldMonthlyCost !== monthlyCost"
            >{{ oldMonthlyCost }} €</s
          >
          <span data-cy="final-monthly-costs">{{ monthlyCost }} €</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="allowedEdit">
      <v-spacer />
      <v-btn
        v-if="allowedEdit"
        @click=""
        >Speichern</v-btn
      >
    </v-card-actions>
  </v-card>
  <v-dialog
    v-model="dialog.open"
    persistent>
    <LicenceReviewPopup
      @close="dialog.open = false"
      @save="dialog.onSuccess"
      :monthly-costs="monthlyCost"
      :yearly-costs="0"
      :additional-costs="additionalPrice"
      :remaining-days="remainingDays"
      :charge-needed="chargeNeeded"
      :initial-items="initialItems"
      :items="items"
      :modules-added="modulesAdded"
      :modules-added-additional="modulesAddedAdditional"
      :modules-removed="modulesRemoved" />
  </v-dialog>
  <v-dialog v-model="addressDialog.open">
    <InvoiceAdressView :success="addressDialog.onSuccess" />
  </v-dialog>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { computed, onBeforeMount, onMounted, ref, toRef, watch } from "vue";
import { useTranslation } from "i18next-vue";
import { Ref } from "vue";
import { toRaw } from "vue";
import { useMainStore } from "@/stores/mainStore";
import { listModule } from "@/types/global";
import { useModules } from "./moduleComposable";
import LicenceReviewPopup from "@/components/dialogs/LicenceReviewPopup.vue";
import { useAuthStore } from "@/stores/authStore";
import InvoiceAdressView from "@/components/dialogs/InvoiceAdressView.vue";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();
const mainStore = useMainStore();
const authStore = useAuthStore();

const dialog = ref({
  open: false,
  onSuccess: () => {}
});

const addressDialog = ref({
  open: false,
  onSuccess: () => {}
});

const emit = defineEmits(["moduleUpdate"]);

const props = withDefaults(
  defineProps<{
    allowedEdit: boolean;
    slots: object;
    allSlots;
    current_status: string;
    licence_id: number;
  }>(),
  { allSlots: {}, current_status: null }
);

defineExpose({
  getInfos,
  saveModules
});

const {
  headers,
  items,
  oldMonthlyCost,
  monthlyCost,
  modulesAdded,
  modulesAddedAdditional,
  modulesRemoved,
  additionalCharge,
  additionalPrice,
  remainingDays,
  initialItems,
  chargeNeeded,
  loadPreview
} = useModules(
  props.allowedEdit,
  toRef(() => props.slots),
  toRef(() => props.allSlots),
  toRef(() => props.current_status),
  toRef(() => props.licence_id)
);

function getInfos() {
  return {
    monthlyCost: monthlyCost.value,
    additionalCharge: additionalCharge.value,
    modulesRemoved: modulesRemoved.value
  };
}

function setupCustomer() {
  addressDialog.value.open = true;
}

function saveModules(callback: () => void) {
  dialog.value.open = true;
  chargeNeeded.value > 0 && loadPreview();
  if (!authStore.user.stripe) {
    dialog.value.onSuccess = setupCustomer;
    addressDialog.value.onSuccess = callback;
  } else {
    dialog.value.onSuccess = callback;
  }
}
</script>
